/**
 * @generated SignedSource<<330bf38cf8192267fbe9f255492b2f63>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useResourceMatchCount_query$data = {
  readonly resourceMatches: {
    readonly pageInfo: {
      readonly total: number | null | undefined;
    };
  };
  readonly " $fragmentType": "useResourceMatchCount_query";
};
export type useResourceMatchCount_query$key = {
  readonly " $data"?: useResourceMatchCount_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useResourceMatchCount_query">;
};

import useResourceMatchCountRefetchQuery_graphql from './useResourceMatchCountRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterElement"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": useResourceMatchCountRefetchQuery_graphql
    }
  },
  "name": "useResourceMatchCount_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filterElement"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "ResourceMatchConnection",
      "kind": "LinkedField",
      "name": "resourceMatches",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7eecbd63d380e088b5b3716356918d8c";

export default node;
